module.exports = __webpack_public_path__ + "media/win.72f1c566.webm";